// components/ProductCard.jsx
import { useState } from "react";
import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="products-list-item bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Product Image */}
      <div className="product-header relative overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800">
        <img 
          src={product.image} 
          alt={product.name}
          className={`product-image w-full h-50 object-cover transition-transform duration-500 ${isHovered ? 'scale-120' : 'scale-110'}`}
        />
        {isHovered && (
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
            <Link 
              to={`/product/${product.id}`}
              className="px-4 py-2 bg-white text-gray-900 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              View Details
            </Link>
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="product-title p-4">
        <h3 className="font-bold text-lg text-gray-900 dark:text-white truncate">
          {product.name}
        </h3>
        <p className="text-2xl font-bold text-blue-600 dark:text-blue-400 mt-2">
          {product.price}
        </p>
      </div>

      <div className="product-content px-4 pb-4 space-y-1">
        <div className="text-sm text-gray-600 dark:text-gray-400">
          Brief infos: Anabolic Pharma
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-500">
          Pack: {product.pack}
        </div>
      </div>

      {/* Add to Cart Button */}
      <div className="px-4 pb-4">
        <button className="w-full py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
          Add to Cart
        </button>
      </div>
    </div>
  );
}